import { FC } from 'react'
import CustomLabel from '../CustomLabel'
import CustomInput from '../CustomInput'
import { maxLengthRule } from '../../utils/formRules'
import { TControls } from '../../../features/userInfoForm/types'

const Country: FC<TControls> = ({ control }) => (
  <div>
    <CustomLabel label="Country"/>
    <CustomInput
      name="locality"
      control={control}
      rules={{
        maxLength: maxLengthRule(35)
      }}
    />
  </div>
)
export default Country
